import { useLastValidValues } from "../../utils/form/useLastValidValues.esm.js";
import { COMMON_PERCENT_CONFIG, COMMON_AMOUNT_CONFIG } from "../../utils/zhl-calculator.esm.js";
const FieldConfig = {
  homePrice: {
    name: "homePrice",
    config: {
      ...COMMON_AMOUNT_CONFIG
    }
  },
  other: {
    name: "other",
    config: {
      ...COMMON_PERCENT_CONFIG
    }
  },
  percentage: {
    name: "percentage"
  }
};
const useLastValidDownPaymentValues = (form) => {
  return useLastValidValues(form, (values) => {
    return {
      fields: {
        homePrice: values.homePrice,
        percentage: values.percentage
      }
    };
  });
};
export {
  FieldConfig,
  useLastValidDownPaymentValues
};
